export default __webpack_public_path__ + "static/media/logo2.4b930b0d.png";